exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearfix[data-v-4eae7c85]:after,.clearfix[data-v-4eae7c85]:before{display:table;content:\"\"}.clearfix[data-v-4eae7c85]:after{clear:both}", ""]);

// exports
